<div [ngClass]="boxClass">
  <ng-container *ngIf="text; else elseTemplate">
    <span>{{ text }}</span>
  </ng-container>
  <ng-template #elseTemplate
    ><span #textElement><ng-content></ng-content></span
  ></ng-template>
  <nv-icon *ngIf="icon"
    [name]="icon"
    [color]="color"
    [isInverted]="!isInverted"
    nvAriaLabel [ariaLabelText]="iconAriaLabel" ariaTargetElement="svg"
  >
  </nv-icon>
</div>
